package team.platforma.chatdata.table

import kotlin.Long
import kotlin.String

public data class MokChat(
  public val id: Long,
  public val aiModelId: Long,
  public val userId: Long,
  public val name: String,
)
